import type { MessageRewriteAction } from 'bundles/enterprise-admin-messaging-v2/components/AIMessageModal/types';

/**
 * Instruction prefixes for the tone/length pills on the Review and send
 * screen. Each rewrite reuses the `generateEmailContent` API: we prepend one
 * of these to the original email body and send it as the prompt. The BE's base
 * prompt handles the structured JSON response format — these instructions must
 * NOT include directives like "return only the body" that would override it.
 *
 * These are model instructions (sent to the API), not rendered UI, so they are
 * intentionally NOT wrapped in `_t()`.
 */
export const TONE_PROMPT_INSTRUCTIONS: Record<MessageRewriteAction, string> = {
  shorten:
    'Rewrite the following learner email to be noticeably shorter and more concise. Keep the core message, the same intent, and the call to action.',
  expand:
    'Rewrite the following learner email to be more detailed and thorough, adding helpful context and elaboration. Keep the same intent and the call to action.',
  more_casual:
    'Rewrite the following learner email in a warmer, more casual and conversational tone. Keep the same intent and the call to action.',
  more_formal:
    'Rewrite the following learner email in a more formal, professional tone. Keep the same intent and the call to action.',
  add_urgency:
    'Rewrite the following learner email to add a clear sense of urgency that motivates the learner to act now, without being pushy. Keep the same intent and the call to action.',
};

/** Builds the rewrite prompt: tone instruction prefixed to the original email body. */
export const buildTonePrompt = (action: MessageRewriteAction, originalBody: string): string =>
  `${TONE_PROMPT_INSTRUCTIONS[action]}\n\n${originalBody}`;
